import { OnDestroy, OnInit, isDevMode } from '@angular/core';
import { environment } from '../environments/environment';
import { LocalizationService } from '@services/localization.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '@services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import localEn from '@angular/common/locales/en-CA';
import localFr from '@angular/common/locales/fr-CA';
import { registerLocaleData } from '@angular/common';
import { DateAdapter } from '@angular/material';
import { CheckForUpdateService } from '@services/check-for-update.service';
import { NgcCookieConsentService } from 'ngx-cookieconsent';
import { CookieService } from 'ngx-cookie-service';
import { COOKIE_CONSENT_COOKIE_NAME, COOKIE_CONSENT_LANGUAGE_RESOURCE_KEY } from './cookie-config';
var AppComponent = /** @class */ (function () {
    function AppComponent(translate, localization, authService, route, router, adapter, translateService, checkForUpdateService, //   Doesn't need to be called, its constructor will start it up.
    ccService, cookieService) {
        this.localization = localization;
        this.authService = authService;
        this.route = route;
        this.router = router;
        this.adapter = adapter;
        this.translateService = translateService;
        this.checkForUpdateService = checkForUpdateService;
        this.ccService = ccService;
        this.cookieService = cookieService;
        this.title = 'app';
        this.env = environment;
        this._subs = [];
        // Cookie   Consent
        this.initCookieConsentLocalization();
        this.initCookieConsentEvents();
        translate.addLangs(['en-CA', 'fr-CA']);
        translate.setDefaultLang('fr-CA');
        localization.setDefaultLocale('fr-CA');
        //  use locale from storage if available
        var storedLocale = localStorage.getItem('locale');
        localStorage.setItem('update-available', 'false');
        if (storedLocale) {
            localization.setLocale(storedLocale);
        }
        else {
            localization.setLocale('fr-CA');
        }
    }
    Object.defineProperty(AppComponent.prototype, "addSub", {
        set: function (sub) {
            this._subs.push(sub);
        },
        enumerable: true,
        configurable: true
    });
    AppComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.localization.initLangChange();
        this.translateService.onLangChange.subscribe(function (event) {
            _this.adapter.setLocale(event.lang);
            _this.initCookieConsentLocalization();
        });
        if (!this.authService.loggedIn()) {
            this.authService.logout().subscribe(function (_) {
                if (_this.route && _this.route.routeConfig && _this.route.routeConfig.path !== '/reset-password') {
                    _this.router.navigate(['/login']);
                }
            });
        }
        registerLocaleData(localEn, 'en-CA');
        registerLocaleData(localFr, 'fr-CA');
    };
    AppComponent.prototype.initCookieConsentEvents = function () {
        var _this = this;
        // subscribe to cookieConsent observables to react to main events
        this.addSub = this.ccService.popupOpen$.subscribe(function () {
            // you can use this.ccService.getConfig() to do stuff...
            console.log('Cookie Consent Popup Open   ');
        });
        this.addSub = this.ccService.popupClose$.subscribe(function () {
            // you can use this.ccService.getConfig() to do stuff...
            console.log('Cookie Consent Closed   ');
            // this.ccService.destroy()
        });
        this.addSub = this.ccService.initialize$.subscribe(function (event) {
            // the cookieConsent has been successfully initialized.
            // It's now safe to use methods on NgcCookieConsentService that require it, like `hasAnswered()` for eg...
            console.log("Cookie Consent initialized: " + JSON.stringify(event));
        });
        this.addSub = this.ccService.statusChange$.subscribe(function (event) {
            // you can use this.ccService.getConfig() to do stuff...
            console.log('Cookie Consent Status Changed   ', event, _this.cookieService.getAll());
            if (event.status === 'deny') {
                // Delete all cookies except the cookie consent one.
                var all = _this.cookieService.getAll();
                for (var _i = 0, _a = Object.keys(all); _i < _a.length; _i++) {
                    var cookieKey = _a[_i];
                    if (cookieKey !== COOKIE_CONSENT_COOKIE_NAME)
                        _this.cookieService.delete(cookieKey);
                }
            }
        });
        this.addSub = this.ccService.revokeChoice$.subscribe(function () {
            // you can use this.ccService.getConfig() to do stuff...
            console.log('Cookie Consent Revoke Choice   ');
            // this.cookieService.deleteAll();
        });
        this.addSub = this.ccService.noCookieLaw$.subscribe(function (event) {
            // you can use this.ccService.getConfig() to do stuff...
            console.log('Cookie Consent No Cookie Law   ');
        });
    };
    AppComponent.prototype.initCookieConsentLocalization = function () {
        var _this = this;
        this.translateService.get(COOKIE_CONSENT_LANGUAGE_RESOURCE_KEY).subscribe(function (localizedText) {
            var config = _this.ccService.getConfig();
            config.content = config.content || {};
            // Override default messages with the translated ones
            config.content.allow = localizedText['Allow'];
            config.content.deny = localizedText['Deny'];
            config.content.dismiss = localizedText['Dismiss'];
            config.content.header = localizedText['Header'];
            config.content.href = localizedText['Href'];
            config.content.link = localizedText['Link'];
            config.content.message = localizedText['Message'];
            config.content.policy = localizedText['Policy'];
            config.content.target = localizedText['Target'];
            config.content.close = localizedText['Close'];
            console.log('isDevMode', isDevMode());
            // if (!isDevMode())
            config.enabled = true;
            _this.ccService.destroy(); // remove previous cookie bar (with default messages)
            _this.ccService.init(config); //   update config with translated messages
        });
    };
    AppComponent.prototype.ngOnDestroy = function () {
        this._subs.forEach(function (s) { return s.unsubscribe(); });
    };
    return AppComponent;
}());
export { AppComponent };
